/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU = (observed count × number of synonymous codons for the amino acid) ÷ (total count of all codons for that amino acid). A value of 1 means no bias.`)
};

const es_rscu_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU = (conteo observado × número de codones sinónimos del aminoácido) ÷ (conteo total de todos los codones de ese aminoácido). Un valor de 1 significa que no hay sesgo.`)
};

const de_rscu_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU = (beobachtete Anzahl × Anzahl synonymer Codons für die Aminosäure) ÷ (Gesamtanzahl aller Codons für diese Aminosäure). Ein Wert von 1 bedeutet keine Verzerrung.`)
};

const nl_rscu_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU = (waargenomen aantal × aantal synonieme codons voor het aminozuur) ÷ (totale aantal van alle codons voor dat aminozuur). Een waarde van 1 betekent geen voorkeur.`)
};

const fr_rscu_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU = (décompte observé × nombre de codons synonymes pour l'acide aminé) ÷ (décompte total de tous les codons pour cet acide aminé). Une valeur de 1 signifie aucun biais.`)
};

const it_rscu_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU = (conteggio osservato × numero di codoni sinonimi per l'amminoacido) ÷ (conteggio totale di tutti i codoni per quell'amminoacido). Un valore di 1 significa nessun bias.`)
};

const pt_br2_rscu_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU = (contagem observada × número de códons sinônimos do aminoácido) ÷ (contagem total de todos os códons daquele aminoácido). Um valor de 1 significa nenhum viés.`)
};

const pt_rscu_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU = (contagem observada × número de codões sinónimos do aminoácido) ÷ (contagem total de todos os codões desse aminoácido). Um valor de 1 significa ausência de viés.`)
};

const ja_rscu_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU = (実際のカウント数 × そのアミノ酸の同義コドン数) ÷ (そのアミノ酸のすべてのコドンの総カウント数)。値が1であれば偏りがないことを意味します。`)
};

const zh_rscu_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU = （观测计数 × 该氨基酸的同义密码子数）÷（该氨基酸所有密码子的总计数）。值为 1 表示没有偏好。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_faq_a2", locale)
	if (locale === "en") return en_rscu_faq_a2(inputs)
	if (locale === "es") return es_rscu_faq_a2(inputs)
	if (locale === "de") return de_rscu_faq_a2(inputs)
	if (locale === "nl") return nl_rscu_faq_a2(inputs)
	if (locale === "fr") return fr_rscu_faq_a2(inputs)
	if (locale === "it") return it_rscu_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_faq_a2(inputs)
	if (locale === "pt") return pt_rscu_faq_a2(inputs)
	if (locale === "ja") return ja_rscu_faq_a2(inputs)
	return zh_rscu_faq_a2(inputs)
};